import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { deleteRequestAttendance } from "../../../axios/Eventlog/EventLogApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const RemoveRequestEventDialog = ({ userId, onClose, onRefresh }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (loading) return;
    onClose();
  };

  const handleRemoveEventLog = async () => {
    setLoading(true);
    try {
      const response = await deleteRequestAttendance(
        userId,
        localStorage.getItem("i18nextLngId")
      );

      if (response?.data?.message) {
        handleCloseDialog();
        toast.success(t("common.content-195"));
        onRefresh?.();
      } else {
        toast.error(t("common.content-196"));
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t("common.network-timeout"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="delete"
      title={t("common.content-193")}
      subtitle={t("common.content-194")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleRemoveEventLog}
    />
  );
};

export default RemoveRequestEventDialog;
